<script setup>
import { useForm } from '@inertiajs/inertia-vue3';
import { ref } from 'vue';

import CreateUser from '@/Pages/Users/Create.vue';

const form = useForm({
    email: '',
    name: '',
	user_type: props.user_type,
	permissions: [],
	notify: true,
	primary_phone_number: '',
})

const props = defineProps({
    errors: {
        type: Object,
        default: () => ({}),
    },
	roles: {
		type: Array,
		required: true,
	},
	organisation: {
		type: Object,
		required: false,
	},
	user_type: {
		type: String,
		default: 'user',
	},
})

const userPermissions = ref([])

function createUser() {
    form.transform((data) => {
		data.permissions = data.user_type == 'admin' ? [] : userPermissions.value
		return data
	}).post('/users')
}

function setPermissions(permissions) {
	userPermissions.value = permissions
}
</script>

<template>
	<CreateUser
		:user="form"
		:errors="errors"
		:roles="roles"
		:organisation="organisation"
		@create:users="createUser"
		@set-permissions="setPermissions"
	/>
</template>